import defaults from "tailwindcss/stubs/config.full.js";
export default defaults.theme;

export const themeFn = (key) => {
  return defaults.theme[key];
};
